<template>
    <div class="manage-box">
        <admin-header></admin-header>
        <admin-sidebar></admin-sidebar>
        <div class="wrapper-box" v-loading="loading" :class="{'content-collapse':collapse}">
            <!-- <v-breadcrumb></v-breadcrumb> -->
            <tag-view></tag-view>
            <transition name="component-fade" mode="out-in">
                <router-view :key="key" v-if="isRouterAlive"></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
import AdminHeader from "@/components/header/AdminHeader";
import AdminSidebar from "@/components/header/AdminSidebar";
import vBreadcrumb from "@/components/header/breadcrumb";
import TheFooter from "@/components/TheFooter";
import tagView from "@/components/tagView/tagView";
import bus from "@/utils/bus";
export default {
    name: "AdminLayOut",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true,
            collapse: false,
            loading: false,
        };
    },
    components: {
        AdminHeader,
        TheFooter,
        AdminSidebar,
        vBreadcrumb,
        tagView
    },
    computed: {
        key() {
            return this.$route.fullPath;
        }
    },
    created() {
        bus.$on("collapse", msg => {
            this.collapse = msg;
        });
        // 数据请求加载动画
        bus.$on('showloading', msg => {
            this.loading = msg
        })
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        }
    }
};
</script>

<style scoped>
.manage-box {
    min-height: 100vh;
    /* display: flex;
    flex-direction: column;
    flex: auto; */
    text-align: left;
}
.wrapper-box {
    position: absolute;
    left: 250px;
    right: 0;
    top: 60px;
    bottom: 0;
    /* padding-bottom: 30px; */
    transition: left 0.3s ease-in-out;
    background: #f8f8f8;
    overflow-y: auto;
}
.wrapper-box.content-collapse {
    left: 65px;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
    font-weight: 500;
    color: #606266;
}
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
    opacity: 0;
}
</style>
